import React, { useEffect, useState } from 'react'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import Card from '@auteco/components/sharedComponents/Card/Card'
import {
  CategorySection,
  ManagerSection,
  ProgressBars,
} from '@auteco/components/snopComponents'
import { getProgressBars, getGeneralState, postGeneralState} from '@auteco/services/snopServices'
import useStyles from './styles'
import SynchronizatioPage from '../SynchronizationPage/SynchronizationPage'

const SnopPage = () => {
  // TODO:
  // desarrollar la sección para sincronización y junta
  const classes = useStyles()
  const [role, setRole] = useState('')
  const [infoBars, setInfoBars] = useState({})
  const [state, setState] = useState(1)

  const getInfoBars = async () => {
    const response = await getProgressBars()
    if (response) {
      setInfoBars(response)
    }
  }

  const getState = async () => {
    const response = await getGeneralState()
    if (response) {
      setState(response.estado_id)
    } 
  }


  const handleFinish = async  () => {
  await postGeneralState({"estado_id":3})
    await getState()
  }


  const returnHome = () => {
    setRole('')
    getInfoBars()
  }

  useEffect(() => {
    getState()
     postGeneralState({"estado_id":1})
    getInfoBars()
  }, [])

  if(state === 3 || state === 4){
    return <SynchronizatioPage  state={state} getState={getState}/>
  }

  if(state === 5){
    return <h1>Ciclo finalizado ✅</h1>
  }

  return (
    <>
      <CardTitle title="Planeación de la demanda" />
      {role === '' && (
        <Card className={classes.cardContainer}>
          <ProgressBars info={infoBars} />
          {infoBars.rol !== null && (
            <>
              <Button
                style={{ width: '200px', margin: '20px auto' }}
                variant="contained"
                color="tumblr"
                onClick={() => setRole(infoBars.rol_id)}
              >
                Inicio
              </Button>
              {/* <p>{infoBars.rol}</p> */}
              {infoBars.rol === 'Gerente' && (
                <Button
                  style={{ width: '200px', margin: '20px auto' }}
                  variant="contained"
                  color="warning"
                //   disabled={infoBars.total !== infoBars.gerente}
                  onClick={() => handleFinish()}
                >
                  Sincronizar
                </Button>
              )}
            </>
          )}
        </Card>
      )}
      {role === 1 && <CategorySection handleReturnHome={returnHome}/>}
      {role === 2 && <ManagerSection handleReturnHome={returnHome} />}
    </>
  )
}

export { SnopPage }
